import type { FeatureCollection } from "geojson";
import { useEffect, useState } from "react";

export function useBoundary(onBoundaryReady?: (b: FeatureCollection) => void) {
  const [boundary, setBoundary] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    fetch("/bcp-boundary.geojson")
      .then(r => (r.ok ? r.json() : Promise.reject(new Error("Boundary load failed"))))
      .then(fc => {
        setBoundary(fc);
        onBoundaryReady?.(fc);
      })
      .catch(console.error);
  }, [onBoundaryReady]);

  return boundary;
}
